import { FC } from "react"
import { useSelector } from "react-redux"
import { Switch } from "antd"
import {
  IPreferencesMenuItem,
  IStateRequestUpdate,
  PreferencesMenuTypeEnum
} from "Data/interfaces/Preferences/IPreferences"
import Select from "Components/UI/Select"
import { hasSelectNotificationsOptions } from "Components/UI/PreferencesModal/useOptions"
import { getTheme } from "Store/MultiDomain/MultiDomain.selector"
import { Container, Content } from "./styles"

interface ICheckAndSelectItem {
  activeType: PreferencesMenuTypeEnum
  item: IPreferencesMenuItem
  itemParentId: string
  index: number
  onStateUpdate: (values: IStateRequestUpdate) => void
}

const CheckAndSelectItem: FC<ICheckAndSelectItem> = ({
  activeType,
  itemParentId,
  item,
  index,
  onStateUpdate
}) => {
  const theme = useSelector(getTheme)

  const handleUpdate = (valueId: string, value: boolean | string) => {
    onStateUpdate({
      Type: activeType,
      itemParentId: itemParentId,
      itemChildrenId: item.Id,
      valueId: valueId,
      value: value
    })
  }

  return (
    <Container>
      <Content>
        {item.Items?.map(itemChildren => (
          <div key={itemChildren.Id} className="rowParent">
            <div className="row">
              <span className="rowText">
                <span className="rowTitle">
                  {itemChildren.TitleSwitch}
                </span>
                <span className="rowDescription">
                  {itemChildren.DescriptionSwitch}
                </span>
              </span>
              <span className="rowChange">
                <Switch
                  size="small"
                  className="antdSwitch"
                  checked={itemChildren.ValueSwitch}
                  onChange={() => handleUpdate(
                    itemChildren.Id,
                    !itemChildren.ValueSwitch
                  )}
                />
              </span>
            </div>

            <div className="row">
              <span className="rowText">
                <span className="rowTitle">
                  {itemChildren.TitleSelect}
                </span>
                <span className="rowDescription">
                  {itemChildren.DescriptionSelect}
                </span>
              </span>
              {itemChildren.SelectType && (
                <span className="rowChange">
                  <Select
                    options={hasSelectNotificationsOptions[itemChildren.SelectType]}
                    value={itemChildren.ValueSelect}
                    size="small"
                    className="select"
                    disabled={!itemChildren.ValueSwitch}
                    notShowIcon={!itemChildren.ValueSwitch}
                    customBackgroundColor={theme.colors.secondary.secondary}
                    righticon={6}
                    onChange={(value) => handleUpdate(itemChildren.Id, value)}
                  />
                </span>
              )}
            </div>
          </div>
        ))}
      </Content>
    </Container>
  )
}

export default CheckAndSelectItem
